//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            loading: false, // 加载状态
            finished: true, // 加载结束
            refreshing: false, // 下拉状态
            pageParams: {
                pageNum: 0,
                pageSize: 10
            },
            notesLists: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            playTabs: [
                {
                    title: '全部'
                },
                {
                    title: '景点',
                    id: '1554720058076'
                },
                {
                    title: '自驾游',
                    id: '1554720058018'
                },
                {
                    title: '寻访',
                    id: '1554720058096'
                },
                {
                    title: '徒步',
                    id: '1554720058072'
                },
                {
                    title: '目的地',
                    id: '1554720058077'
                },
                {
                    title: '摄影',
                    id: '1554720058071'
                },
                {
                    title: '热门',
                    id: '1554720058145'
                },
                {
                    title: '采风游',
                    id: '1554720058021'
                },
                {
                    title: '美食游',
                    id: '1554720058015'
                },
                {
                    title: '推荐',
                    id: '1554720058089'
                }
            ],
            tabIndex: 0,
            tags: []
        };
    },
    // created() {
    //   this.$loading.show();
    //   this.getList();
    // },
    mounted() {
        this.getList();
    },
    computed: {
        currId() {
            return JSON.parse(localStorage.getItem('userInfo')).user.username;
        }
    },
    methods: {

        edit(item){
            this.$router.push({
                name: 'travelsNotes',
                query: {
                    id: item.id
                }
            });
        },

        jumpPage(item) {
            this.$router.push({
                path: `/strategyDetails/${item.id}?type=own`,
            });
        },

        toPage(){
            this.$router.push({
                path: '/travels-notes',
            });
        },

        getTravelContent(id, token) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/noteSelf/selfList?page=0&size=50&username=${id}&access_token=${token}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async getList() {
            try {
                const self = this;
                // 请求
                let result = await self.getTravelContent(this.currId, JSON.parse(localStorage.getItem('userInfo')).access_token);
                if (result.data) {
                    const data = result.data;

                    self.notesLists = data;
                    for (let i = 0; i < self.notesLists.length; i++) {
                        self.notesLists[i].tags = self.notesLists[i].tags.split(',');
                        const x = self.notesLists[i].tags.map(item => {
                            return item.split('/');
                        });
                        self.notesLists[i].tags = x;
                    }
                    self.loading = false;
                    if (data.length < 10) {
                        self.finished = true;
                    } else {
                        self.pageParams.pageNum++;
                        self.finished = true;
                    }
                }

            } catch (error) {
                console.log(error, 'error');

            }
        },
        getTabIndex(index) {
            if (index === this.tabIndex) return;
            this.notesLists = [];
            this.pageParams.pageNum = 0;
            this.tabIndex = index;
            this.getList();
        },
        // 上拉加载
        onLoad() {
            this.getList();
        },
        // 下拉刷新
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.refreshing = false;
        },
        // 重置
        reset() {
            this.notesLists = [];
            this.pageParams.pageNum = 0;
        }
    }
};
